module.exports = __webpack_public_path__ + "static/media/logout.813cab18.svg";